import { NavigationRoutes } from 'common/constants';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import {
  CardSection,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import { ScheduleCardHeader } from '../style';

export default function TransferCashCard() {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  return (
    <CardSection>
      <ScheduleCardHeader $style={style}>
        <Text variant="HeadingXSmall">
          {t('common:detail_extra', {
            extra: t(`common:transfer_cash`),
          })}
        </Text>
        <HOCInput keys={['approvalable']}>
          {(value) => (
            <Button
              buttonType="secondary"
              onClick={() =>
                navigate(NavigationRoutes.TransfersView, {
                  id: value.approvalable.id,
                })
              }
            >
              {t('common:view_details')}
            </Button>
          )}
        </HOCInput>
      </ScheduleCardHeader>
      <Separator gap={16} />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.transactionAt"
            label={t('common:transaction_at')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.number"
            label={t('common:number')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.description"
            label={t('common:description')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            label={t('common:amount')}
            name="approvalable.amount"
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            label={t('common:from_account')}
            name="approvalable.fromAccountableName"
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            label={t('common:to_account')}
            name="approvalable.toAccountableName"
          />
        </HalfContainer>
      </SectionContainer>
    </CardSection>
  );
}

const style: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
